<template>
  <div id="returnsAndRefunds">
    <div class="contentRight2">
      <div class="rightHead">
        <div class="tabTitle" @click="jump">总览</div>
        <div class="tabTitle bottomLine">退货退款订单</div>
      </div>
      <div class="head row alignCenter">
        <el-select size="small" v-model="searchValue.statusValue" placeholder="状态">
          <el-option
            v-for="item in status"
            :key="item.statusName"
            :label="item.statusName"
            :value="item.statusName"
          ></el-option>
        </el-select>
        <div style="margin-left:20px;">
          <el-date-picker
            v-model="searchValue.time"
            type="daterange"
            size="small"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            :clearable="false"
          ></el-date-picker>
        </div>
        <div style="margin-left:20px;">
          <el-button size="small" @click="search" type="primary">搜索</el-button>
          <el-button size="small" @click="clearSearch">重置</el-button>
          <!-- <el-button size="small">订单导出</el-button> -->
        </div>
      </div>
           <div class="information row">
        <div class="ifm-item">
          <div class="montyKey">退货订单笔数(笔)</div>
          <div class="money">{{statisticList.backOrderNum}}</div>
        </div>
        <div class="ifm-item">
          <div class="montyKey">退货总金额(元)</div>
          <div class="money">{{statisticList.backMoney.toFixed(2)}}</div>
        </div>
      </div>
      <div class="content">
        <!-- 表格 -->
        <div>
          <el-table v-if="tableData" :data="tableData" style="width: 100%">
            <el-table-column align="left" prop="goodsName" label="退货商品名称" width="280">
              <template slot-scope="scope">
                <div class="row">
                  <div >
                      <img style="height:50px;width:50px;margin-right:10px;" :src="scope.row.goodsImage" alt="">
                  </div>
                  <div class="column">
                    <div>{{scope.row.goodsName}}</div>
                    <div class="goodsCode">商品码:{{scope.row.goodsId}}</div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="refundTime" label="退货时间" width="180"></el-table-column>
            <el-table-column align="center" prop="turnoverPrice" label="单价">
              <template slot-scope="scope">
                <div>￥{{scope.row.turnoverPrice}}{{scope.row.goodsUnit}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="refundCount" label="数量">
              <template slot-scope="scope">
                <div>{{scope.row.refundCount}}{{scope.row.goodsUnit}}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="refundMoney" label="退货金额"></el-table-column>
            <el-table-column align="center" prop="price" label="状态">
              <template slot-scope="scope">
                <div v-if="scope.row.productSaleStatus == 1">
                  <span class="status">退货退款</span>
                </div>
                <div v-if="scope.row.productSaleStatus == 6">
                  <span class="status">仅退款</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="price" label="操作">
              <template>
                <div>
                  <el-button size="small" type="primary">查看详情</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div v-if="totalNum" class="block" style="float:right;margin-top:10px;">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="1"
            :page-size="7"
            layout="total, prev, pager, next, jumper"
            :total="totalNum"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  findRefundGoodsList,
  getRefundStatistic,
  refundMallOrderDetail,
  findRefundOrderList,
  toRefundOrderDetail,
  saveMallOrderRefund,
  refundGoodsTotalNum
} from "../api";
export default {
  data() {
    return {
     
      totalNum: "",
      tableData: [],
      statisticList: {
        backMoney: 0,
        backOrderNum: 0
      },
      status: [{ statusName: "退货退款" }, { statusName: "退款" }], //状态下拉框
      searchValue: {
        statusValue: "", //搜索状态值
        time: "" //时间
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.userList = userList;
    this.shopInformation = shopInformation;
  
    //  var myDate = new Date();
    // var month = myDate.getMonth() + 1;
    // let str = myDate.getFullYear() + "-" + month + "-" + myDate.getDate();
    this.getRefundStatistic();
    this.findRefundGoodsList();
  },
  methods: {
    jump() {
      this.$router.push("returnsAndRefunds");
    },
    //分页当前页
    handleCurrentChange(val) {
      var searchValue = this.searchValue;
      var orderStatus;
      var productSaleStatus;
      console.log(searchValue);
      if (searchValue.statusValue == "退货退款") {
        orderStatus = -51;
        productSaleStatus = 1;
      } else {
        orderStatus = -50;
        productSaleStatus = 6;
      }
      this.findRefundGoodsList(
        orderStatus,
        searchValue.time[0],
        searchValue.time[1],
        val
      );
    },
    search() {
      var searchValue = this.searchValue;
      var orderStatus;
      var productSaleStatus;
      console.log(searchValue);
      if (searchValue.statusValue == "退货退款") {
        orderStatus = -51;
        productSaleStatus = 1;
      } else if(searchValue.statusValue == "退款"){
        orderStatus = -50;
        productSaleStatus = 6;
      }
      this.getRefundStatistic(
        orderStatus,
        searchValue.time[0],
        searchValue.time[1]
      );
      this.findRefundGoodsList(
        productSaleStatus,
        searchValue.time[0],
        searchValue.time[1]
      );
    },
    clearSearch() {
      this.searchValue = {
        statusValue: "", //搜索状态值
        time: "" //时间
      };
    },
    getRefundStatistic(orderStatus, startDate, endDate) {
      getRefundStatistic({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        orderStatus: orderStatus,
        startDate: startDate,
        endDate: endDate
      }).then(res => {
        console.log(res.data);
        if (res.code == 1) {
          this.statisticList = res.data;
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
        }
      });
    },
    findRefundGoodsList(productSaleStatus, startDate, endDate, pageNo) {
      findRefundGoodsList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        productSaleStatus: productSaleStatus,
        startDate: startDate,
        endDate: endDate,
        row: 7,
        pageNo: pageNo
      }).then(res => {
        console.log(res.data);
        if (res.code == 1) {
          this.tableData = res.data;
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else if(res.code == -1){
             this.tableData =[]
        }
      });
      refundGoodsTotalNum({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        productSaleStatus: productSaleStatus,
        startDate: startDate,
        endDate: endDate,
        row: 7,
        pageNo: pageNo
      }).then(res => {
        console.log(res.data);
        if (res.code == 1) {
          this.totalNum = res.data.totalNum;
        } else if (res.code == 2) {
          this.$message.error(res.msg);
          this.$router.push("/");
        } else {
        }
      });
    }
  }
};
</script>

<style  scoped>
.goodsCode{
    font-size:14px;
font-family:Microsoft YaHei;
font-weight:400;
color:rgba(153,153,153,1);
}
.status {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(249, 72, 72, 1);
  padding: 10px 20px;
  background: #ffe5e6;
}
tr {
  background: #f8f8f8 !important;
}
.content {
  padding: 20px 30px;
}
.montyKey {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(85, 85, 85, 1);
  line-height: 48px;
}
.money {
  font-size: 24px;
  font-weight: bold;
}
.ifm-item {
  display: flex;
  /* flex-grow: 1; */
  /* align-items: center; */
  flex-direction: column;
  width: 25%;
}
.information {
  margin-top: 30px;
  padding: 29px 44px;
  box-sizing: border-box;
  /* width: 100%; */
  background: rgba(248, 248, 249, 1);
}
.bottomLine::after {
  position: absolute;
  content: "";
  bottom: 0;
  left: 0;
  right: 0;
  border: 1px solid #108ee9;
}
.tabTitle {
  cursor: pointer;
  position: relative;
  padding: 0 5px;
  display: inline-block;
  margin: 0 0 0 25px;
  font-size: 15px;
  padding-top: 16px;
  color: #707070;
  height: 100%;
  box-sizing: border-box;
}
.head {
  box-sizing: border-box;
  padding: 21px 33px;
  background: #f8f8f8;
  width: 100%;
  padding-top: 70px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/returnsAndRefundsOrders.vue